import React, { useEffect, useState } from 'react';
import axios from 'axios';
import { formatDistanceToNow } from 'date-fns';
import { Link } from 'react-router-dom';
import Loading from '../../../components/common/loading';
import eventRefs from '../../../assets/eventRef';
import useDarkMode from '../../../hooks/useDarkMode';

export default function DeviceEventLogList({ device }) {
  const dark = useDarkMode();
  const [logs, setLogs] = useState([]);
  const [loading, setLoading] = useState(false);
  const [eventType, setEventType] = useState('');

  useEffect(() => {
    if (!device) return;
    setLoading(true);
    axios
      .get('/v2/eventLogs', {
        params: {
          enclosure_serial_number: device.enclosureSerialNumber,
          limit: 10,
          page: 1,
          eventType: eventType || '',
        },
        headers: { Authorization: 'Bearer ' + localStorage.getItem('token') },
      })
      .then((res) => {
        setLogs(res.data.data || []);
        setLoading(false);
      })
      .catch((err) => {
        console.error('Error fetching device event logs', err);
        setLoading(false);
      });
  }, [device?.enclosureSerialNumber, eventType]);

  const renderName = (log) => {
    const ref = eventRefs.find((e) => e.code == log.eventType);
    return log.name || (ref ? ref.name : log.eventType);
  };

  const renderType = (log) => {
    const ref = eventRefs.find((e) => e.code == log.eventType);
    return ref ? ref.name : log.eventType;
  };

  const renderTriggered = (log) => {
    const isTrig = !!log.triggered;
    return (
      <span style={{ color: isTrig ? 'maroon' : 'forestgreen', fontWeight: 600 }}>
        {isTrig ? 'Triggered' : 'Cleared'}
      </span>
    );
  };

  const renderDetails = (log) => {
    const ref = eventRefs.find((e) => e.code == log.eventType);
    let params = [];
    try {
      params = Array.isArray(log.params)
        ? log.params
        : log.params
        ? JSON.parse(log.params)
        : [];
    } catch (e) {
      params = [];
    }
    if (ref) {
      const tpl = log.triggered ? ref.triggeredDescription : ref.notTriggeredDescription;
      if (tpl) {
        return tpl.replace(/{{param(\d+)}}/g, (_, i) => {
          const idx = parseInt(i, 10) - 1;
          return params[idx] !== undefined ? String(params[idx]) : '';
        });
      }
    }
    return params.length ? JSON.stringify(params) : '';
  };

  return (
    <div
      style={{
        // backgroundColor: dark ? 'rgba(0,0,0,0.3)' : 'rgba(255,255,255,0.3)',
        padding: '15px',
        paddingBottom: '2rem',
        height: '100%',
        display: 'flex',
        flexDirection: 'column',
      }}
    >
      <div
        style={{
          display: 'flex',
          justifyContent: 'space-between',
          paddingBottom: '1rem',
          alignItems: 'center',
        }}
      >
        <span style={{ fontWeight: '600', fontSize: '110%' }}>Event Logs</span>
        {device && (
          <Link
            to={`/devices/connected/${device.enclosureSerialNumber}/event-logs`}
            style={{ fontSize: '90%' }}
          >
            View all
          </Link>
        )}
      </div>
      <div style={{ paddingBottom: '1rem' }}>
        <select
          value={eventType}
          onChange={(e) => setEventType(e.target.value)}
          style={{ width: '100%' }}
        >
          <option value="">Filter by Event</option>
          {eventRefs.map((e) => (
            <option key={e.code} value={e.code}>
              {e.name}
            </option>
          ))}
        </select>
      </div>
      <div style={{ overflowY: 'auto', flex: 1 }}>
        {loading ? (
          <Loading />
        ) : logs.length === 0 ? (
          <div style={{ padding: '0 0 1rem' }}>No event logs found</div>
        ) : (
          <ul style={{ listStyle: 'none', margin: 0, padding: 0 }}>
            {logs.map((log) => (
              <li
                key={log.logId}
                style={{ padding: '0.5rem 0', borderBottom: dark ? '1px solid rgba(255,255,255,0.1)' : '1px solid rgba(0,0,0,0.1)' }}
              >
                <div
                  style={{
                    display: 'flex',
                    justifyContent: 'space-between',
                    alignItems: 'flex-start',
                    gap: '0.5rem',
                  }}
                >
                  <div style={{ display: 'flex', gap: '0.35rem', flexWrap: 'wrap' }}>
                    <Link
                      to={`/devices/connected/${device.enclosureSerialNumber}/event-logs?eventId=${log.eventId}`}
                      style={{ fontWeight: '500', textDecoration: 'underline' }}
                    >
                      {renderName(log)}
                    </Link>
                    <span style={{ fontSize: '85%', color: dark ? '#ccc' : '#555' }}>
                      {renderType(log)} - {renderTriggered(log)}
                    </span>
                  </div>
                  <span style={{ fontSize: '85%', color: dark ? '#ccc' : '#555', whiteSpace: 'nowrap' }}>
                    {formatDistanceToNow(new Date(log.deviceTs), { addSuffix: true })}
                  </span>
                </div>
                {renderDetails(log) && (
                  <div style={{ fontSize: '85%', color: dark ? '#ccc' : '#555', marginTop: '0.25rem' }}>
                    {renderDetails(log)}
                  </div>
                )}
              </li>
            ))}
          </ul>
        )}
      </div>
    </div>
  );
}

